import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Chip,
  CircularProgress,
  //   IconButton,
  //   Tooltip,
} from "@mui/material";
import { IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import MUIDataTable from "mui-datatables";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { getOfferDetail } from "../../apis/cart/apis";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Divider } from "@mui/material";
import moment from "moment";

export default function DetailScreen() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [offer, setOffer] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchOffer = async () => {
      try {
        setLoading(true);

        const response = await getOfferDetail(id);

        setOffer(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchOffer();
  }, [id]);

  const leftAlignedColumn = {
    filter: false,
    sort: false,

    setCellHeaderProps: () => ({
      style: {
        textAlign: "left",
        fontWeight: 600,
      },
    }),

    setCellProps: () => ({
      style: {
        textAlign: "left",
      },
    }),
  };

  const orderColumns = [
    {
      name: "order_number",
      label: "Order Number",
      options: {
        ...leftAlignedColumn,
        customBodyRender: (value, tableMeta) => {
          const row = offer.order_discounts[tableMeta.rowIndex];

          return (
            <Link
              to={`/w86zjruk6q/cart/orders/${row.order_id}/detail`}
              style={{
                textDecoration: "none",
              }}
            >
              {value}
            </Link>
          );
        },
      },
    },
    // {
    //   name: "order_date",
    //   label: "Order Date",
    //   options: {
    //     ...leftAlignedColumn,
    //     customBodyRender: (value) => new Date(value).toLocaleString(),
    //   },
    // },
    {
      name: "order_total",
      label: "Order Total",
      options: {
        ...leftAlignedColumn,
        customBodyRender: (value) => `₹${value}`,
      },
    },
    {
      name: "discount",
      label: "Cost",
      options: {
        ...leftAlignedColumn,
        customBodyRender: (value) => `₹${value}`,
      },
    },
  ];

  const tableOptions = {
    selectableRows: "none",
    download: false,
    print: false,
    filter: false,
    search: false,
    viewColumns: false,
    responsive: "standard",
    elevation: 0,
  };
  if (loading) {
    return (
      <Box p={3}>
        <CircularProgress />
      </Box>
    );
  }

  if (!offer) {return null;}

  return (
    <Box p={3}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Typography variant="h4">{offer.name}</Typography>

        <Tooltip title="Edit Offer">
          <IconButton
            color="primary"
            onClick={() => navigate(`/w86zjruk6q/offers/${offer.id}/edit`)}
          >
            <EditIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <Grid container spacing={2} mb={3}>
        <Grid item xs={12} md={3}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle2">Offer Status</Typography>

            <Chip
              label={offer.is_available ? "Currently Available" : "Unavailable"}
              color={offer.is_available ? "success" : "error"}
            />
          </Paper>
        </Grid>

        <Grid item xs={12} md={3}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle2">Total Cost</Typography>

            <Typography variant="h6">₹{offer.total_discount}</Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={3}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle2">Number of Orders</Typography>

            <Typography variant="h6">{offer.num_orders}</Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={3}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle2">Number of Uses</Typography>

            <Typography variant="h6">{offer.num_applications}</Typography>
          </Paper>
        </Grid>
      </Grid>

      {/* <Box mb={4}>
        <MUIDataTable
          title="Offer Details"
          data={offerDetailRows}
          columns={offerDetailColumns}
          options={{
            selectableRows: "none",
            download: false,
            print: false,
            filter: false,
            search: false,
            viewColumns: false,
            pagination: false,
            responsive: "standard",
            elevation: 0,
          }}
        />
      </Box> */}
      <Grid container spacing={4}>
        <Grid item xs={12} md={5}>
          <Paper elevation={2} sx={{ p: 2, height: "100%" }}>
            <Typography variant="h5" mb={5}>
              Offer Details
            </Typography>

            <Divider />

            <Box sx={{ mt: 2 }}>
              {[
                {
                  label: "Name",
                  value: offer.name,
                },
                {
                  label: "Description",
                  value: offer.description,
                },
                {
                  label: "Type",
                  value: offer.offer_type_display,
                },
                {
                  label: "Incentive",
                  value: offer.incentive,
                },
                {
                  label: "Condition",
                  value: offer.condition,
                },
                {
                  label: "Restrictions",
                  value:
                    offer.start_datetime && offer.end_datetime
                      ? `Available between ${moment(
                        offer.start_datetime,
                      ).format("MMMM D, YYYY, h:mm a")} and ${moment(
                        offer.end_datetime,
                      ).format("MMMM D, YYYY, h:mm a")}`
                      : "-",
                },
                {
                  label: "Num of Vouchers",
                  value: offer.voucher_count,
                },
                {
                  label: "Expires On",
                  value: moment(offer.end_datetime).format(
                    "MMMM D, YYYY, h:mm a",
                  ),
                },
              ].map((field) => (
                <Box key={field.label} display="flex" mb={1.5}>
                  <Typography
                    sx={{
                      minWidth: 150,
                      fontWeight: 500,
                    }}
                  >
                    {field.label}:
                  </Typography>

                  <Typography
                    sx={{
                      flex: 1,
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: field.value || "-",
                    }}
                  />
                </Box>
              ))}
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={7}>
          <MUIDataTable
            title="Orders That Used This Offer"
            data={offer.order_discounts || []}
            columns={orderColumns}
            options={tableOptions}
          />
        </Grid>
      </Grid>

      {/* <Box mb={4}>
        <MUIDataTable
          title="Attached Vouchers"
          data={offer.vouchers || []}
          columns={voucherColumns}
          options={tableOptions}
        /> 
      </Box> */}
      <Box mt={3}>
        <Button
          variant="contained"
          onClick={() => navigate(`/w86zjruk6q/offers/${offer.id}/vouchers`)}
        >
          View Vouchers
        </Button>
      </Box>

      {/* <MUIDataTable
        title="Orders That Used This Offer"
        data={offer.order_discounts || []}
        columns={orderColumns}
        options={tableOptions}
      /> */}
    </Box>
  );
}
